module.exports = __webpack_public_path__ + "static/media/learning-4.535cb291.png";